import React, { useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"

const BazaarInterestForm = () => {
  const [isSubmitted, setIsSubmitted] = useState(true)

  const radioOptions = {
    membership: [
      "PULA Member & PULA Verified Seller",
      "PULA Member (Not PVS)",
      "I live in Pune but not a part of PULA",
      "I do not live in Pune, coming from another city",
    ],
    participated: [
      "Yes",
      "No, I am participating for the first time in PULA Bazaar",
    ],
    season: [
      "Season 43 at Amanora Mall, Hadapsar",
      "Season 44 at Elpro City Square Mall, PCMC",
      "Both",
    ],
    comingOn: [
      "Yes",
      "None at all",
      "Someone else booking their stall will book for me",
      "Will book online later if stalls available",
    ],
    attendees: [
      "0 as someone else is doing my booking who is already there to book stall for them or will book online later if available",
      "1",
      "2",
      "3",
    ],
  }

  const validation = useFormik({
    initialValues: {
      fullName: "",
      contactNumber: "",
      membership: "",
      participated: "",
      season: "",
      comingOn: "",
      attendees: "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Full name is required"),
      contactNumber: Yup.string()
        .matches(/^[0-9]{10}$/, "Contact number must be 10 digits")
        .required("Contact number is required"),
      membership: Yup.string().required("Please select one option"),
      participated: Yup.string().required("Please select one option"),
      season: Yup.string().required("Please select one option"),
      comingOn: Yup.string().required("Please select one option"),
      attendees: Yup.string().required("Please select one option"),
    }),
    onSubmit: () => {
      setIsSubmitted(true)
    },
  })

  document.title = "PULA Bazaar Booking Form | PULA"

  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="newaward-maincontainer pt-4 ">
          <Row className="justify-content-center">
            <Col xs={12} sm={11} md={10} lg={8}>
              <div className="form-section p-4 p-md-5">
                <h4 className="nom-title mb-2" style={{ fontSize: "27px" }}>
                  PULA Bazaar Booking Form Season 43 and 44
                </h4>
                <p className="text-muted mb-4">
                  {isSubmitted
                    ? "Thank you for your interest! We have received your response."
                    : "Please fill in the details below. Fields marked with * are required."}
                </p>

                {isSubmitted ? (
                  <div className="py-4">
                    <h5 className="mb-3">Thank you!</h5>
                    <p className="mb-0">
                      Our team will get in touch with you regarding the bazaar
                      booking details.
                    </p>
                  </div>
                ) : (
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="fullName">
                        Full Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="fullName"
                        name="fullName"
                        type="text"
                        value={validation.values.fullName}
                        onChange={validation.handleChange}
                        invalid={
                          validation.touched.fullName &&
                          Boolean(validation.errors.fullName)
                        }
                      />
                      {validation.touched.fullName &&
                        validation.errors.fullName && (
                          <FormFeedback>
                            {validation.errors.fullName}
                          </FormFeedback>
                        )}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label" htmlFor="contactNumber">
                        Contact Number <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="contactNumber"
                        name="contactNumber"
                        type="text"
                        value={validation.values.contactNumber}
                        onChange={validation.handleChange}
                        invalid={
                          validation.touched.contactNumber &&
                          Boolean(validation.errors.contactNumber)
                        }
                      />
                      {validation.touched.contactNumber &&
                        validation.errors.contactNumber && (
                          <FormFeedback>
                            {validation.errors.contactNumber}
                          </FormFeedback>
                        )}
                    </div>

                    <div className="mb-4">
                      <Label className="form-label d-block">
                        Are you a <span className="text-danger">*</span>
                      </Label>
                      {radioOptions.membership.map(option => (
                        <div className="form-check mb-2" key={option}>
                          <Input
                            id={`membership-${option}`}
                            name="membership"
                            type="radio"
                            className="form-check-input"
                            value={option}
                            checked={validation.values.membership === option}
                            onChange={validation.handleChange}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor={`membership-${option}`}
                          >
                            {option}
                          </Label>
                        </div>
                      ))}
                      {validation.touched.membership &&
                        validation.errors.membership && (
                          <div className="text-danger small">
                            {validation.errors.membership}
                          </div>
                        )}
                    </div>

                    <div className="mb-4">
                      <Label className="form-label d-block">
                        Have you participated with our exhibition earlier?{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      {radioOptions.participated.map(option => (
                        <div className="form-check mb-2" key={option}>
                          <Input
                            id={`participated-${option}`}
                            name="participated"
                            type="radio"
                            className="form-check-input"
                            value={option}
                            checked={validation.values.participated === option}
                            onChange={validation.handleChange}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor={`participated-${option}`}
                          >
                            {option}
                          </Label>
                        </div>
                      ))}
                      {validation.touched.participated &&
                        validation.errors.participated && (
                          <div className="text-danger small">
                            {validation.errors.participated}
                          </div>
                        )}
                    </div>

                    <div className="mb-4">
                      <Label className="form-label d-block">
                        Interested to book for which Season of PULA Bazaar?{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      {radioOptions.season.map(option => (
                        <div className="form-check mb-2" key={option}>
                          <Input
                            id={`season-${option}`}
                            name="season"
                            type="radio"
                            className="form-check-input"
                            value={option}
                            checked={validation.values.season === option}
                            onChange={validation.handleChange}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor={`season-${option}`}
                          >
                            {option}
                          </Label>
                        </div>
                      ))}
                      {validation.touched.season &&
                        validation.errors.season && (
                          <div className="text-danger small">
                            {validation.errors.season}
                          </div>
                        )}
                    </div>

                    <div className="mb-4">
                      <Label className="form-label d-block">
                        Are you coming on 18th January, Sunday for booking?{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      {radioOptions.comingOn.map(option => (
                        <div className="form-check mb-2" key={option}>
                          <Input
                            id={`comingOn-${option}`}
                            name="comingOn"
                            type="radio"
                            className="form-check-input"
                            value={option}
                            checked={validation.values.comingOn === option}
                            onChange={validation.handleChange}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor={`comingOn-${option}`}
                          >
                            {option}
                          </Label>
                        </div>
                      ))}
                      {validation.touched.comingOn &&
                        validation.errors.comingOn && (
                          <div className="text-danger small">
                            {validation.errors.comingOn}
                          </div>
                        )}
                    </div>

                    <div className="mb-4">
                      <Label className="form-label d-block">
                        How many are coming for your booking? Helps us arranging
                        for Breakfast & tea.{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      {radioOptions.attendees.map(option => (
                        <div className="form-check mb-2" key={option}>
                          <Input
                            id={`attendees-${option}`}
                            name="attendees"
                            type="radio"
                            className="form-check-input"
                            value={option}
                            checked={validation.values.attendees === option}
                            onChange={validation.handleChange}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor={`attendees-${option}`}
                          >
                            {option}
                          </Label>
                        </div>
                      ))}
                      {validation.touched.attendees &&
                        validation.errors.attendees && (
                          <div className="text-danger small">
                            {validation.errors.attendees}
                          </div>
                        )}
                    </div>

                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Form>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default BazaarInterestForm
